/**
 * 百度地图API配置
 * {
 *   name: 调用接口的别名
 *   url：api
 *   method：get | post | put | delete
 * }
 */
export default {
  // 根据担保物类型判断是否有权调用地图接口
  getValuationStatus: {
    name: "getValuationStatus",
    url: "/ams/valuation/getValuationStatus",
    method: "get"
  },

  // 获取坐标
  getCoodinate: {
    name: "getCoodinate",
    url: "/ams/valuation/getCoodinate",
    method: "get"
  },

  // 获取司法拍卖均价
  getLitiAvg: {
    name: "getLitiAvg",
    url: "/ams/valuation/getLitiAvg",
    method: "get"
  },

  // 获取房产交易均价
  getEstateAvg: {
    name: "getEstateAvg",
    url: "/ams/valuation/getEstateAvg",
    method: "get"
  },

  // 获取司法拍卖列表
  getAuctionList: {
    name: "getAuctionList",
    url: "/ams/valuation/getAuctionList",
    method: "get"
  },

  // 获取房产交易列表
  getEstateList: {
    name: "getEstateList",
    url: "/ams/valuation/getEstateList",
    method: "get"
  },

  // 获取司法拍卖详情
  getAuctionDetail: {
    name: "getAuctionDetail",
    url: "/ams/valuation/getAuctionDetail",
    method: "get"
  },

  // 获取房产交易详情
  getEstateDetail: {
    name: "getEstateDetail",
    url: "/ams/valuation/getEstateDetail",
    method: "get"
  }
};
